export const isInitialFilled = (value: string) => value.replace(/\./g, '').trim().length >= 2
